import ProductCarousel from './lib/product-carousel';
import { initHomepageVideo } from './components/video';

import './scss/home.scss';

ProductCarousel.createFromSelector('.js-products-carousel');
initHomepageVideo(document.getElementById('home-video'));
